import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "img-arrows-right-left-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("path", { fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", d: "m4.5 13.5-2-2 2-2m-2 2h8m2-4 2-2-2-2m2 2h-8" }));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
